import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const ImportExport = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <g>
      <path
        d="M20.5,9h-5C15.2,9,15,9.2,15,9.5c0,0.3,0.2,0.5,0.5,0.5H20v10H3V10h4.5C7.8,10,8,9.8,8,9.5C8,9.2,7.8,9,7.5,9h-5
			C2.2,9,2,9.2,2,9.5v11C2,20.8,2.2,21,2.5,21h18c0.3,0,0.5-0.2,0.5-0.5v-11C21,9.2,20.8,9,20.5,9z"
      />
      <path
        d="M6.5,3h2v0C10.2,3,11,3.8,11,5.5v8.8l-2.1-2.1c-0.2-0.2-0.5-0.2-0.7,0C8,12.2,8,12.4,8,12.5c0,0.1,0,0.3,0.1,0.4l3,3
			c0.2,0.2,0.5,0.2,0.7,0l3-3c0.2-0.2,0.2-0.5,0-0.7s-0.5-0.2-0.7,0L12,14.3V5.5C12,3.2,10.8,2,8.5,2v0h-2C6.2,2,6,2.2,6,2.5
			C6,2.8,6.2,3,6.5,3z"
      />
    </g>
  </SvgIcon>
);

export default ImportExport;
